// extracted by mini-css-extract-plugin
export default {"container":"bank_details_filter_modal_container__Fli0A","buttonGroup":"bank_details_filter_modal_buttonGroup__edMkN"};